import IconV2 from '@/components/v2/IconV2';

const labelMap = {
  delete: 'Delete',
  put: 'Update',
  post: 'Create',
  skip: 'Skip',
  warn: 'Warning',
  fail: 'Failure',
  info: 'info'
};

const getActionValue = (action) => {
  if (action === 'create') {
    return 'post';
  }
  if (action === 'update') {
    return 'put';
  }
  if (action === 'error') {
    return 'fail';
  }
  return action;
};

const ActionIcon = ({ action }) => {
  const actionValue = getActionValue(action);

  return <IconV2 title={labelMap[actionValue]}>{actionValue && <div className={`comp-action-icon ${actionValue}`}>{labelMap[actionValue]?.charAt(0) || '?'}</div>}</IconV2>;
};

export default ActionIcon;
